<template>
    <section>
        <ds-modal
            :is-open="isOpen"
            class="regular-modal"
            show-back
            :size="modalSize"
            :title.sync="fullName"
            @back="isOpen = false"
        >
            <div class="popup-div">
                <div class="popup-div-orders" data-qa="orders-heading">
                    Orders
                </div>

                <div class="popup-div-orders-margin">
                    <span class="popup-div-orders-length">{{ allOrdersDataForModalPopup.length }}</span>
                    <span class="popup-div-orders-result"> results </span>
                </div>

                <div class="table-scroller">
                    <ds-table-grid
                        ref="table"
                        :data="allOrdersDataForModalPopup"
                        align="center"
                        :sort-field="sortField"
                        :sort-ascending="sortAscending"
                        @sort="sortTable"
                    >
                        <ds-table-grid-column
                            label="Order name"
                            width="125"
                        >
                            <template slot-scope="allOrder">
                                <span :title="allOrder.title">
                                    {{ modifyValidationMessage(allOrder.title) }}
                                </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Payment plan"
                            width="125"
                        >
                            <template slot-scope="allOrder">
                                <span :title="allOrder.payPlanStatus">
                                    {{ modifyValidationMessage(allOrder.payPlanStatus) }}
                                </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Status"
                            width="125"
                        >
                            <template slot-scope="allOrder">
                                <span :title="allOrder.refundStatus">
                                    {{ modifyValidationMessage(allOrder.refundStatus) }}
                                </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Total"
                            width="60"
                        >
                            <template slot-scope="allOrder">
                                <span>
                                    {{ allOrder.formattedInvoiceTotal }}
                                </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Paid"
                            width="60"
                        >
                            <template slot-scope="allOrder">
                                <span>
                                    {{ allOrder.formattedTotalPaid }}
                                </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Balance"
                            width="60"
                        >
                            <template slot-scope="allOrder">
                                <span :class="checkValidMessage(allOrder.currentDuePositive,allOrder.currentDueNegative)">
                                    {{ allOrder.formattedCurrentDue }}
                                </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Remaining balance"
                            width="98"
                        >
                            <template slot-scope="allOrder">
                                <span>
                                    {{ allOrder.formattedRemainingBalance }}
                                </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Date"
                            sortable
                        >
                            <template slot-scope="allOrder">
                                <span>
                                    {{ dateFormatDate(allOrder.dueDate, 'MMM D, YYYY') }}
                                </span>
                            </template>
                        </ds-table-grid-column>
                    </ds-table-grid>
                </div>
            </div>
        </ds-modal>
    </section>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

export default {
    props: {
        contact: Object,
    },

    data() {
        return {
            url: '/app/ecommContactDisplay',
            allOrdersDataForModalPopup: [],
            allOrdersLimit: 1000,
            contactId: this.contact.id,
            contactOwnerType: 'CONTACT',
            modalSize: 'full',
            sortAscending: false,
            sortField: 'lastUpdated',
            isOpen: false,
        };
    },

    mounted() {
        this.loadAllOrdersDataForModalPopup();
    },

    computed: {
        fullName() {
            return `${this.contact.firstName} ${this.contact.lastName}`;
        },
    },

    methods: {
        loadAllOrdersDataForModalPopup() {
            axios.get(`${this.url}/${this.contactId}/recentOrders/${this.allOrdersLimit}/${this.contactOwnerType}`).then((response) => {
                this.allOrdersDataForModalPopup = response.data;
            }).catch(() => {
                this.$error({ message: 'unable to get all orders details' });
            });
        },

        showModal() {
            this.isOpen = true;
            document.querySelector('body').classList.add('overlay-active');
        },

        closeModal() {
            this.isOpen = false;
            document.querySelector('body').classList.remove('overlay-active');
        },

        dateFormatDate(date, format = 'll') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },

        checkValidMessage(positive, negetive) {
            if (positive) {
                return 'order-current-due-positive';
            }

            if (negetive) {
                return 'order-current-due-negative';
            }

            return 'order-current-due-normal';
        },

        modifyValidationMessage(message) {
            message = (message ?? 'N/A') || (message === '' ? 'N/A' : message);

            if (message && message.length > 20) {
                return `${message.slice(0, 20)}...`;
            }

            return message;
        },

        sortTable({ ascending }) {
            const factor = ascending === true ? -1 : 1;

            this.sortAscending = ascending;
            this.allOrdersDataForModalPopup = this.allOrdersDataForModalPopup.sort((prev, next) => {
                if (prev.dueDate > next.dueDate) return -1 * factor;
                if (prev.dueDate < next.dueDate) return 1 * factor;

                return 0;
            });
        },
    },
};

</script>

<style lang="scss" scoped>
.table-scroller {
    white-space: nowrap;
}

.order-current-due-positive {
    color: $color-red;
}

.order-current-due-negative {
    color: $color-blue;
}
.order-current-due-normal {
    color: $color-gray-dark;
}

.popup-div {
    margin-left: 6.5rem;
    margin-right: 6.5rem;
}

.popup-div-orders {
    width: 6.5rem;
    height: 2.5rem;
    font-size: $font-size-jumbo;
    margin-bottom: $spacing-250;
    color: $color-gray-darkest;
}

.popup-div-orders-margin {
    margin-bottom: $spacing-200;
}

.popup-div-orders-length {
    width: 2.4375rem;
    height: 2rem;
    font-size: $font-size-jumbo;
    color: $color-text;
}

.popup-div-orders-result {
    color: $color-gray-dark
}

@media only screen and ($small) {
    .popup-div {
        margin-left: $spacing-025;
        margin-right: 0.3125rem;
    }
}
</style>
